import { EXTENSION_ID } from '@/env'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function sendMessageToExtension<T>(action: string, data: Record<string, any> = {}): Promise<T> {
  if (!window.chrome?.runtime) {
    return Promise.resolve(true as T)
  }

  try {
    const message = chrome.runtime.sendMessage(EXTENSION_ID, { action, ...data })
    const timeout = new Promise<T>((_, reject) =>
      setTimeout(() => reject(new Error('Extension message timeout')), 3000)
    )
    return Promise.race([message, timeout])
  } catch (error) {
    console.log(error)
    return Promise.reject(error)
  }
}
